

































import {
  PropType,
  computed,
  defineNuxtComponent,
  ref,
  watch
} from '~/utils/nuxt3-migration'
import { ciUser } from '~/icons/source/solid/user'
import { ciPencil } from '~/icons/source/solid/pencil'
import { ciUpload } from '~/icons/source/solid/upload'

export default defineNuxtComponent({
  props: {
    src: {
      type: String as PropType<string | null>,
      required: false,
      default: null
    },
    size: {
      type: String as PropType<
        'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'
      >,
      default: 'xl'
    },
    wide: {
      type: Boolean,
      default: false
    },
    counter: {
      type: Number,
      default: 0
    },
    onlineIndicator: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const userHasAvatar = ref(props.src !== null)

    watch(
      () => props.src,
      newVal => {
        userHasAvatar.value = newVal !== null
      }
    )

    const sizeClasses = computed(() => {
      switch (props.size) {
        case 'xs':
          return 'tw-size-4 tw-rounded-sm after:tw-rounded-sm [&>*]:tw-rounded-sm'
        case 'sm':
          return 'tw-size-5 tw-rounded-md after:tw-rounded-md [&>*]:tw-rounded-md'
        case 'md':
          return 'tw-size-6 tw-rounded-md after:tw-rounded-md [&>*]:tw-rounded-md'
        case 'lg':
          return 'tw-size-8 tw-rounded-lg after:tw-rounded-lg [&>*]:tw-rounded-lg'
        case 'xl':
          return 'tw-size-12 tw-rounded-lg after:tw-rounded-lg [&>*]:tw-rounded-lg'
        case '2xl':
          return 'tw-size-16 tw-rounded-lg after:tw-rounded-lg [&>*]:tw-rounded-lg'
        case '3xl':
          return 'tw-size-20 tw-rounded-lg after:tw-rounded-lg [&>*]:tw-rounded-lg'
      }
    })
    return {
      ciUser,
      ciUpload,
      ciPencil,
      sizeClasses,
      userHasAvatar
    }
  }
})
